import { LifeBuoy, IndianRupee, BarChart3 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { AdminLoginForm } from "../components/auth";
import SharedHeader from "@/components/SharedHeader";
import SharedFooter from "@/components/SharedFooter";

// Branded, role-locked staff login portals. Each portal binds login to a single
// role server-side (the `portal` id is enforced in /admin/auth/login).
const PORTALS = {
  support: {
    portal: "support",
    redirectTo: "/admin/tickets",
    title: "Support Portal",
    subtitle: "Sign in to manage support tickets",
    icon: LifeBuoy,
    gradient: "from-sky-50 via-cyan-50 to-blue-50",
    iconBg: "bg-sky-100 text-sky-600",
  },
  finance: {
    portal: "finance",
    redirectTo: "/admin/finance",
    title: "Finance Portal",
    subtitle: "Sign in to view finance dashboards",
    icon: IndianRupee,
    gradient: "from-emerald-50 via-green-50 to-teal-50",
    iconBg: "bg-emerald-100 text-emerald-600",
  },
  analyst: {
    portal: "analyst",
    redirectTo: "/admin/dashboard",
    title: "Analyst Portal",
    subtitle: "Sign in to view reports & analytics",
    icon: BarChart3,
    gradient: "from-violet-50 via-purple-50 to-fuchsia-50",
    iconBg: "bg-violet-100 text-violet-600",
  },
};

export default function RolePortalLoginPage({ portalKey }) {
  const cfg = PORTALS[portalKey];
  const handleBack = () => {
    window.location.href = window.location.origin + "/";
  };

  if (!cfg) return null;
  const Icon = cfg.icon;

  return (
    <div className={`min-h-screen bg-gradient-to-br ${cfg.gradient} flex flex-col`} data-testid={`portal-${cfg.portal}`}>
      <header className="bg-white/80 backdrop-blur-md border-b border-slate-100">
        <SharedHeader transparent={true} />
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-8">
        <Card className="w-full max-w-md shadow-xl bg-white">
          <CardContent className="p-6 sm:p-8">
            <div className="flex justify-center mb-2">
              <div className={`w-14 h-14 rounded-2xl flex items-center justify-center ${cfg.iconBg}`}>
                <Icon className="h-7 w-7" />
              </div>
            </div>
            <AdminLoginForm
              onBack={handleBack}
              portal={cfg.portal}
              redirectTo={cfg.redirectTo}
              title={cfg.title}
              subtitle={cfg.subtitle}
            />
          </CardContent>
        </Card>
      </main>

      <SharedFooter />
    </div>
  );
}
